import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ENV_APP_PROJECT } from '@apps-common/lib/environment'
import { IAuthLoginMessageResponse } from '@apps-common/types/auth'

const project = ENV_APP_PROJECT

export const loginMessage = async (): Promise<IAuthLoginMessageResponse> => {
  const url = project === 'my-monitoring' ? '/my-monitoring/account/LoginMessage' : '/account/LoginMessage'

  return axios.get(url).then((res) => res?.data?.data)
}

type QueryFnType = typeof loginMessage

type Props = {
  config?: QueryConfig<QueryFnType>
}

export const useLoginMessage = ({ config }: Props = {}) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ retry: 3, ...config },
    queryKey: ['loginMessage'],
    queryFn: () => loginMessage(),
    throwOnError: false
  })
